/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../pages/auth'
import { ErrorsPage } from '../pages/errors/ErrorsPage'
import { RootState } from '../../setup'
import { MasterInit } from '../../_metronic/layout/MasterInit'
import { SearchFilterPage } from '../pages/searchFilter'
const Routes: FC = (props) => {
  const isAuthorized: any = useSelector<RootState>(({ auth }: any) => auth.sessionId, shallowEqual);
  const rights: any = useSelector<RootState>(({ auth }: any) => auth.rights, shallowEqual);

  return (
    <>
      {
        rights['login_portal'] ?
          (
            <Switch>
              {isAuthorized === 'closed' ? (
                <Route>
                  <AuthPage />
                </Route>
              ) : (
                <Redirect from='/auths' to='/' />
              )}

              <Route path='/error' component={ErrorsPage} />
              <Route path='/logout' component={Logout} />
              <Route path='/searchfilter' component={SearchFilterPage} />

              {isAuthorized === 'closed' ? (
                <Redirect to='/auth/login' />
              ) : (
                <>
                  <MasterLayout>
                    <PrivateRoutes />
                  </MasterLayout>
                </>
              )}
            </Switch>
          ) : (
            <Switch>
              <Route>
                <AuthPage />
              </Route>
            </Switch>
          )
      }
      <MasterInit />
    </>
  )
}

export { Routes }
